import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({routes: routes.data})

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.noAuth) && !window.localStorage.getItem('access_token')) {
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    next()
  }
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js